<template>
  <div :class="{ 'user-info': true, 'is-small': size === 'small' }">
    <button
      :title="$t('프로필')"
      type="button"
      class="user-profile-button officehome-gnb-profile"
      :class="{ 'icon-button__selected': isProfileDetailVisible, 'is-small': size === 'small' }"
      v-if="cacheOfficeInfo.office.office_id && cacheUserInfo.office_user_no"
      @click="toggleProfileDetail"
    >
      <img :src="imgSrc" alt="" class="photo-36" />
    </button>
    <template v-if="isProfileDetailVisible">
      <SwitchProfile
        ref="profileDetail"
        tabindex="0"
        @blur="closeDropdownMenu"
        :currentVariantHeader="size === 'small'"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SwitchProfile from './SwitchProfile.vue';

export default {
  name: 'Profile',
  components: {
    SwitchProfile,
  },
  props: {
    size: {
      type: String,
      required: false,
      default: 'normal',
    },
    isProfileDetailVisible: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState({
      cacheOfficeInfo: (state) => state.cache.officeInfo,
      cacheUserInfo: (state) => state.cache.userInfo,
    }),
    imgSrc() {
      // @Todo office.hiworks.com에 종속적이라 추후 window의 PATH_INFO참조 무조건 제거
      let domain = null;

      if (window.PATH_INFO && window.PATH_INFO.DOMAIN) {
        if (window.PATH_INFO.URLTYPE === 'G') {
          domain = window.PATH_INFO.GROUPID;
        } else {
          domain = window.PATH_INFO.DOMAIN;
        }
      } else {
        domain = this.cacheOfficeInfo.office.office_id;
      }

      return process.env.VUE_APP_OFFICE_URL + '/' + domain + '/common/profile/me';
    },
  },
  methods: {
    toggleProfileDetail() {
      this.$emit('set-profile-detail-visible', !this.isProfileDetailVisible);
      !this.isProfileDetailVisible && this.$nextTick(() => this.$refs.profileDetail.$el.focus());
    },
    closeDropdownMenu(e) {
      const isMenuButton = Boolean(e.relatedTarget?.closest('div.user-info'));
      if (!isMenuButton) this.$emit('set-profile-detail-visible', false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/base/variables.scss';

.user-info {
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 900px) {
    position: relative;
  }

  .user-profile-button {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    padding: 3px;
    &:hover {
      background-color: rgba(159, 166, 173, 0.2);
    }
    .photo-36 {
      display: block;
      width: 100%;
      border-radius: 100%;
    }

    &.is-small {
      width: 34px;
      height: 34px;
    }
  }
}

.user-info.is-small {
  .user-profile-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 34px;
    height: 34px;
  }

  .user-info-detail {
    top: $managementHeaderHeight;
  }
}
</style>
